/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2019-11-14 17:18:37
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-05-11 19:40:18
 */
import md5 from 'md5'
import CryptoJS from './crypto'
import {
  prefixUrl,
  formData,
  apiData,
  apiDatatext,
  commonParams,
} from './config'
import axios from 'axios'
// import store from '../../store'
import qs from 'qs'
import { uuid } from 'common/js/util.js'
// let userid = store.state.sUserInfo.userid // 用户id
// let groupUrl = testUrl.groupChat  // 接口地址
// let kxUrl = testUrl.webkx // 接口地址
let pending = [] // 声明一个数组用于储存每个请求的取消函数和请求标识
// let cancelToken = axios.CancelToken // 初始化取消请求的构造函数
// let arr = [] // 区分是请求还是响应的头部
const _api = {} // 接口方法映射

// 增加接口方法
function addApi() {
  for (let key in apiData) {
    let apiDataVal = apiData[key]
    let url = apiDataVal.url || apiDataVal // 接口地址
    let prefix = apiDataVal.prefix || '' // 接口前缀
    let reqUrl = prefix ? `${prefixUrl[prefix]}/${url}` : `${prefixUrl.pro}/${url}` // 加上前缀的完整接口地址
    let reqMethod = apiDataVal.method || 'post' // 请求方式
    let responseType = apiDataVal.resType || 'json' // 响应数据格式
    let contentType = apiDataVal.contentType || 'application/json'  // 请求数据格式
    let headersData = apiDataVal.headers || null // 请求头带的信息
    let headers = {'Content-Type': contentType, ...headersData} // 请求数据格式
    let urlData = apiDataVal.data || {} // url中带的数据
    let isCheckRequest = typeof(apiDataVal.isCheckRequest) == 'boolean' ? apiDataVal.isCheckRequest : true // 是否需要阻止该接口多次连续请求
    // 根据Content-Type，统一将参数格式进行转化
    let transformRequest = contentType == 'application/x-www-form-urlencoded' ? [data => {
      return qs.stringify(data)
    }] : [data => {
      // 对 data 进行任意转换处理
      return JSON.stringify(data)
    }]
    _api[key] = function(data) {
      let reqData = Object.assign({}, commonParams, urlData, data) // 传入请求方法的数据(若有公共参数也加上)
      // 防止重复发相同请求
      // console.log('isCheckRequest',isCheckRequest)
      if (!isRepeatReq(reqUrl, reqData) && isCheckRequest) {
        return Promise.resolve('')
      }
      console.log('reqUrl', reqUrl)
      // console.log('contentType', contentType)
      let getData, postData
      reqMethod == 'get' ? getData = reqData : getData = null // get请求的参数
      reqMethod == 'post' ? postData = reqData : postData = null // post请求的参数
      // 返回 接口函数
      return axios({method: reqMethod, url: reqUrl, params: getData, data: postData, responseType: responseType, headers: headers, transformRequest: transformRequest }).then(res => {
        return Promise.resolve(res)
      })
    }
  }
}
addApi()

export const API = _api

// 判断重复请求——判断当前请求是否已经在“正在发送”状态
function isRepeatReq(reqUrl, reqData, isRes) {
  let reqFlag = `${reqUrl}&${qs.stringify(reqData)}`

  // console.log('reqFlag', reqFlag)
  // 当前请求 已经在发送状态了
  if (pending.indexOf(reqFlag) !== -1) {
    // 若是response回调，说明请求完成，清除pending中的 该请求
    if (isRes) {
      // console.log('请求结束时，会进来', reqFlag)
      pending.splice(pending.indexOf(reqFlag), 1)
      // console.log('pending', pending)
    // 若是再次请求相同接口+相同参数，直接停止该请求
    } else {
      // console.log('相同请求,第一次未结束,第二次进入时,会进来', reqFlag)
      return false
    }
  // 当前请求 在pending中不存在，是一个新请求
  } else {
     // 往pending中存入该请求
    if (!isRes) {
      // console.log('发送第一次请求时会进入', reqFlag)
      pending.push(reqFlag)
      return true
    }
  }
}

// 添加请求拦截器——重设reqId和globalId
axios.interceptors.request.use(function (config) {
  // 在发送请求之前重设reqId和globalId
  config.headers.gloableId = uuid();
  config.headers.reqId = uuid();
  // console.log('axios.interceptors.request config', config);
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 添加响应拦截器——去掉重复请求标识
axios.interceptors.response.use(
  response => {
    // console.log('location.href', location.href)
    if (response && response.data && response.data.code == '08144004') {
      location.href = '/front/login'
      // window.location.href = 'http://admin-dev.999time.cn/front/login'
      // window.location.href = 'http://admin-test.999time.cn/front/login'
      // window.location.href = 'https://admin.xdqtech.com/front/login'
      // window.location.href = hostManage.loginUrl
      return Promise.reject('您未登录, 即将跳转登录！')
    }
    // console.log('response', response)
    // code = response.config.url.split('api/')[1]
    let reqUrl = response.config.url
    // data = qs.parse(response.config.data)
    let reqData = (response.config.data && JSON.parse(response.config.data)) || (response.config.params) || {}
    // reqData = response.config.data || (response.config.params && JSON.parse(response.config.params)) || {}
    isRepeatReq(reqUrl, reqData, true)
    return response
  },
  error => {
    pending = []
    return Promise.reject(error)
  }
)

// 添加响应拦截器——去掉重复请求标识
// axios.interceptors.response.use(
//   response => {
//     if (response.data.code == '08144004') {
//       //  window.location.href = 'http://admin-test.999time.cn/front/login'
//         window.location.href = 'http://admin-dev.999time.cn/front/login'
//        // window.location.href = 'http://admin.999time.cn/front/login'
// 	    // window.location.href = 'http://192.168.50.71:8008/login'
//       return Promise.reject('您未登录, 即将跳转登录！');
//     }
//     let reqData, code, data
//     code = response.config.url.split('/pro/')[1]
//     // console.log('请求返回')
//     if(response.config.data){
//       try{
//         data = JSON.parse(response.config.data)
//       }
//       catch(e){
//       }
//     }else{
//       data=response.config.data
//     }
//     // console.log('请求返回', data, response)
//     isRepeatReq(code, data, true)
//     return response
//   },
//   error => {
//     pending = []
//     return Promise.reject(error)
//   }
// )


// /** 群聊接口请求内容封装
//  *
//  * @param {*Object/接口参数} data
//  * @param {*String/区别接口路径} code
//  * @param {*Array/参数中需要加密的字段} cryptNames
//  */
// export function requestDataHandler(data, code, cryptNames) {
//   data = JSON.parse(JSON.stringify(data))
//   // 选择内容加密
//   if (cryptNames) {
//     cryptNames.forEach(e => {
//       data[e] = CryptoJS.encryption(data[e])
//     })
//   }
//   // 加密报文
//   const body = CryptoJS.encryption(data)
//   // 签名
//   const sign = md5(body)
//   // const newData = Object.assign({}, commonParams, {
//   //   transCode: code, // 交易码
//   //   body: body,
//   //   sign: sign,
//   //   requestTime: formatDate(Date.now(), 'yyMMddhhmmss')
//   // })
//   const newData = {
//     body: body,
//     sign: sign,
//   })
//   return newData
// }

// 增加接口方法
// function addApi() {
//   for (let key in apiData) {
//     let val = apiData[key]
//     let url = typeof apiData[key] == 'object' ? apiData[key].url : apiData[key]
//     let test = typeof apiData[key] == 'object' ? apiData[key].test : ''
//     _api[key] = function(data) {
//       let reqUrl = test ? `${testUrl[test]}/${url}` : `${testUrl.testApi}/${url}`
//       let reqData = Object.assign({}, commonParams, data)
//       // 防止重复发相同请求
//       if (!isRepeatReq(url, reqData) && !test) {
//         return Promise.resolve('')
//       }
//       // console.log('reqData', reqData)
//       // // 获取请求参数
//       // if (key === 'logIn') {
//       //   var reqData = requestDataHandler(data, url, ['password'])
//       // } else {
//       //   var reqData = requestDataHandler(data, url)
//       // }
//       // 请求方式
//       if (val.method) {
//         return axios.get(reqUrl, reqData).then(res => {
//           return Promise.resolve(res)
//         })
//       } else {
//         let formDatas = test ? {headers: {'apptag': apiData[key].apptag, terminal: apiData[key].terminal}} : formData
//         return axios.post(reqUrl, reqData, formDatas).then(res => {
//           return Promise.resolve(res)
//         })
//       }
//     }
//   }

//   for (let key in apiDatatext) {
//     let val = apiDatatext[key]
//     let url = typeof apiDatatext[key] == 'object' ? apiDatatext[key].url : apiDatatext[key]
//     _api[key] = function(data) {
//       let reqUrl = test ? `${testUrl[test]}/${url}` : `${testUrl.testApi}/${url}`
//       let reqData = Object.assign({}, commonParams, data)
//       // 防止重复发相同请求
//       if (!isRepeatReq(url, reqData)) {
//         return Promise.resolve('')
//       }
//       // 请求方式
//       return axios.post(reqUrl,data).then(res => {
//         return Promise.resolve(res)
//       })
//     }
//   }
// }



// WEBPACK FOOTER //
// ./src/api/index.js